import { render, staticRenderFns } from "./orderbillcount.vue?vue&type=template&id=f5092116&"
import script from "./orderbillcount.vue?vue&type=script&lang=js&"
export * from "./orderbillcount.vue?vue&type=script&lang=js&"
import style0 from "./orderbillcount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports